import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent } from '@ionic/react'
import { UseHeader, MktEmpty, ResultAlert, CouponItem, CouponDetail } from '@cps'
import ActivityApi from '@api/activity.api'
import { modalLayer, useHistoryNew } from '@utils'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import i18n from 'i18next'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const MyPrizes: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { activityId } = match.params as any
  const [prizes, setPrizes] = useState<any>([])
  const [couponDetails, setCouponDetails] = useState<any>({})
  const goBack = () => {
    history.goBack()
  }
  const transCoupons = (list: any) => {
    const couponIds: any = []
    list.map((item) => {
      item.coupons.map((coup) => {
        if (!couponIds.includes(coup.couponId)) {
          couponIds.push(coup.couponId)
        }
      })
    })
    ActivityApi.getCouponsList({ couponIds: couponIds, status: 'all' }).then(res => {
      const obj = keyBy(res, 'couponId')
      setCouponDetails(obj)
    })
  }

  const goDetail = (data: any) => {
    modalLayer(CouponDetail, { type: 'get', couponInfo: data })
  }

  const showRecord = (prizeInfo: any) => {
    modalLayer(ResultAlert, {
      title: prizeInfo.name,
      btnTitle: i18n.t('pay.acknowledged'),
      children: prizeInfo && prizeInfo.coupons.map((item: any, index: number) => {
        const hasItem: any = couponDetails[item.couponId]
        return hasItem && (
          <div className='coupon-block' key={`${index}-${item.couponId}`}>
            <CouponItem type='use' couponInfo={hasItem} cnt={item.couponCnt > 1 ? item.couponCnt : ''}></CouponItem>
          </div>)
      })
    }).then(() => { }, () => { })
  }
  useEffect(() => {
    ActivityApi.getActiveDetail(activityId).then((res: any) => {
      setPrizes(res.extra.prize)
      transCoupons(res.extra.prize)
    })
  }, [])
  return (
    <IonPage className='active-prizes-page'>
      <UseHeader title={i18n.t('mkt.pointCard.activeRewards')} onBack={goBack}></UseHeader>
      <IonContent className='page-content'>
        <div className='page-body'>
          {
            prizes.length > 0 ? (
              <>
                {
                  prizes && prizes.map((item: any, index: number) => {
                    return (
                      item.coupons && item.coupons.map((cItem) => {
                        const hasItem: any = couponDetails[cItem.couponId]
                        return (hasItem &&
                          <div className='coupon-block' key={cItem.couponId}>
                            <CouponItem type='get' couponInfo={couponDetails[cItem.couponId]} onClick={goDetail} onDetail={goDetail}></CouponItem>
                          </div>)
                      })
                      // <PrizeItem
                      //   key={index} info={item} couponMap={couponDetails} onClick={() => {
                      //     showRecord(item)
                      //   }}
                      // >
                      // </PrizeItem>
                    )
                  })
                }
              </>) : <MktEmpty text={i18n.t('mkt.activity.noPrizes')}></MktEmpty>
          }
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(MyPrizes)
